.cc{border:1px solid #ddd;}